<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <div class="title-bc">{{ $t("m.index.setting.accountManage") }}</div>
        </div>
        <div class="box-header-right">
          <div class="line-right">
            <el-button type="primary" @click="changePasswordDialog = true">{{
              $t("m.button.changePwd")
            }}</el-button>
            <el-button type="primary" @click="logout">{{
              $t("m.placeholder.logout")
            }}</el-button>
          </div>
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div
          class="box-item box-half"
          style="width: 100%; background-color: transparent; margin-bottom: 0px; padding-bottom: 0px"
        >
          <div class="box-item-img">
            <!--            <el-upload
                    action="http://www.ihbcoffee.com/roaster/manage/user/upload.do"
                    name="upload_file"
                    :with-credentials="false"
                    :on-success="uploadSuccess"
            >
              <el-avatar :size="100"
                         :src="user.photo"></el-avatar>
            </el-upload>-->
            <el-avatar :size="100" :src="aa"></el-avatar>
          </div>
          <div class="box-item-text" style="width: 100%">
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">{{
                  $t("m.accountManage.username")
                }}</span>
                <el-input placeholder="" type="text" v-model="user.name">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">{{
                  $t("m.accountManage.phone")
                }}</span>
                <el-input placeholder="" type="text" v-model="user.phone">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">{{
                  $t("m.accountManage.email")
                }}</span>
                <el-input placeholder="" type="text" v-model="user.email">
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div
          class="box-item box-half"
          style="width: 100%; background-color: transparent;margin-top: 0px; padding-top: 0px;"
        >
          <div class="box-item-text" style="width: 100%">
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">{{
                  $t("m.index.setting.company")
                }}</span>
                <el-input placeholder="" type="text" v-model="user.company">
                </el-input>
              </div>
            </div>
            <div class="flex flex-between input-line">
              <div class="flex input-wrap has-title" style="width: 100%">
                <span class="cus-input-title">{{
                  $t("m.index.setting.address")
                }}</span>
                <el-input placeholder="" type="text" v-model="user.address">
                </el-input>
              </div>
            </div>
            <div style="margin-top: 20px">
              <el-button
                type="warning"
                style="float: right"
                @click="saveUserInfo"
                >{{ $t("m.button.save") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--------修改密码弹框---------->
    <el-dialog
      :title="$t('m.button.changePwd')"
      center
      :modal-append-to-body="false"
      :visible.sync="changePasswordDialog"
    >
      <el-form
        :model="pwdForm"
        ref="pwdForm"
        :rules="pwdForm.rules"
        label-width="130px"
      >
        <el-form-item
          :label="$t('m.accountManage.oldPassword')"
          prop="oldPassword"
        >
          <el-input v-model="pwdForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('m.accountManage.newPassword')"
          prop="newPassword"
        >
          <el-input v-model="pwdForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('m.accountManage.checkPassword')"
          prop="checkPassword"
        >
          <el-input v-model="pwdForm.checkPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex flex-center">
        <div @click="changePasswordDialog = false" class="dialog-footer-btn">
          {{ $t("m.button.return") }}
        </div>
        <div type="primary" @click="changePassword" class="dialog-footer-btn">
          {{ $t("m.button.save") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      user: {
        name: "",
        phone: "",
        email: "",
        photo: "",
        company: "",
        address: "",
      },
      changePasswordDialog: false,
      oldPwd: "",
      newPwd: "",
      checkPwd: "",
      pwdForm: {
        resetPasswordVisible: false,
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
        rules: {
          oldPassword: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the original password"
                  : "请输入原密码",
              trigger: "blur",
            },
          ],
          newPassword: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the new password"
                  : "请输入新密码",
              trigger: "blur",
            },
          ],
          checkPassword: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the new password again"
                  : "请输入确认新密码",
              trigger: "blur",
            },
          ],
        },
        showCancel: true,
      },
      photo: localStorage.photo,

      date: "",
      remarks: "",
      selectValue: "",
      dialogTableVisible: false,
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      this.$http
        .get("/manage/user/get_user_info.do")
        .then(
          function(resp) {
            console.info(resp);
            this.user = resp.data.data.user;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    saveUserInfo() {
      this.$confirm(
        this.$t("m.alert.updateUser"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
             background: "rgba(0, 0, 0, 0.7)",
          });
          this.loading = loading;
          const params = {
            name: this.user.name,
            phone: this.user.phone,
            email: this.user.email,
            photo: this.user.photo,
            company: this.user.company,
            address: this.user.address,
          };
          this.$http
            .post("/manage/user/update_information.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  localStorage.setItem("photo", this.user.photo);
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
          loading.close();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    uploadSuccess(response, file, fileList) {
      console.info(response.data.url);
      console.info(file);
      console.info(fileList);
      this.$message.success(this.$t("m.alert.updateSuccess"));
      this.user.photo = response.data.url;
    },
    changePassword() {
      this.$refs["pwdForm"].validate((valid) => {
        if (valid) {
          console.log("密码修改表单验证通过");
          if (this.pwdForm.newPassword != this.pwdForm.checkPassword) {
            this.$message.error("新密码和确认密码不相同");
          } else {
            this.$confirm(
              this.$t("m.alert.changeTip"),
              this.$t("m.alert.reminder"),
              {
                confirmButtonText: this.$t("m.alert.confirm"),
                cancelButtonText: this.$t("m.alert.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                let params = new URLSearchParams();
                params.append("passwordOld", this.pwdForm.oldPassword);
                params.append("passwordNew", this.pwdForm.newPassword);
                this.$http
                  .post("/manage/user/reset_password.do", params)
                  .then(
                    function(resp) {
                      if (resp.data.success) {
                        this.$message.success(this.$t("m.alert.updateSuccess"));
                      } else {
                        this.$message.erroe("密码更新失败");
                      }
                    }.bind(this)
                  )
                  .catch((err) => {
                    console.info(err);
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: this.$t("m.alert.canceled"),
                });
              });
          }
        }
      });
    },
    logout() {
      this.$confirm(this.$t("m.alert.logout"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/manage/user/logout.do")
            .then(
              function(resp) {
                console.info(resp);
                let language = localStorage.aqbCofeLang;
                localStorage.clear();
                localStorage.aqbCofeLang = language;
                this.$router.push("/login");
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
  },
};
</script>

<style scoped>
.el-textarea__inner {
  height: 250px;
}

.box-item .box-item-img img {
  width: 80px;
}
</style>
